/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerhandleinvalid2Inputs */

const en_organizerhandleinvalid2 = /** @type {(inputs: Organizerhandleinvalid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 to 30 characters: lowercase letters, digits and _`)
};

const de_organizerhandleinvalid2 = /** @type {(inputs: Organizerhandleinvalid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 bis 30 Zeichen: Kleinbuchstaben, Ziffern und _`)
};

/**
* | output |
* | --- |
* | "3 to 30 characters: lowercase letters, digits and _" |
*
* @param {Organizerhandleinvalid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerhandleinvalid2 = /** @type {((inputs?: Organizerhandleinvalid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerhandleinvalid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerhandleinvalid2(inputs)
	return de_organizerhandleinvalid2(inputs)
});
export { organizerhandleinvalid2 as "organizerHandleInvalid" }